export function scheduleOwner(item) {
  if (item.created_by_role === 'admin' || item.timeline_type === 'official' || item.source_type === 'official' || item._type === 'official') return { label: '管理员订单', color: '#d8b76a' };
  if (item.source_type === 'driver_extra' || item.timeline_type === 'driver_extra') return { label: `司机：${item.created_by_name || '未记录'}`, color: '#8eccc3' };
  const key = item.created_by_id || item.created_by_name || '';
  const hash = Array.from(key).reduce((value, character) => (value * 31 + character.charCodeAt(0)) >>> 0, 0);
  return { label: `调度：${item.created_by_name || '未记录'}`, color: `hsl(${hash % 360} 65% 76%)` };
}
